let notificationListener = null;

export const NotificationManager = {
    subscribe: (listener) => {
        notificationListener = listener;
    },

    push: (message, isSuccess = true) => {
        if (notificationListener) {
            notificationListener({
                id: Date.now(),
                message,
                isSuccess
            })
        }
    },

    //Clean the sub if the component dismounts
    unsubscribe: () => {
        notificationListener = null;
    }
}